import { render, staticRenderFns } from "./FullTextPdfEventLogItem.vue?vue&type=template&id=85ea62ca&"
import script from "./FullTextPdfEventLogItem.vue?vue&type=script&lang=js&"
export * from "./FullTextPdfEventLogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports